import type { Method } from 'axios'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ServiceUnavailable } from 'common/errors/ServiceUnavailable'

const httpClient = axios.create({
  withCredentials: true,
})

export const pageEditorHttpClient = async <T>(
  url: string,
  method: Method = 'GET',
  options: AxiosRequestConfig<T> = {},
): Promise<T> => {
  const response: AxiosResponse<T> = await httpClient({
    method,
    url: `/api/dashboard/page-editor/${url}`,
    ...options,
  })
  return response.data
}

export const initializePageEditorHttpClientInterceptors = () => {
  httpClient.interceptors.response.use(
    response => response,
    error => {
      if (axios.isAxiosError(error) && error.response?.status === 503) {
        throw new ServiceUnavailable(error.response)
      }
      throw error
    },
  )
}
